const getAvatarColor = (userId) => {
  // add up asci values of their name
  //   let asciiValSum = 0;
  //   let i;
  //   for (i = 0; i < name.length; i++) {
  //     asciiValSum += name.charCodeAt(i);
  //   }
  //   let colorIndex = asciiValSum % avatarColors.length;
  let colorIndex = userId % avatarColors.length;
  return avatarColors[colorIndex];
};

const avatarColors = [
  "blue",
  "blueviolet",
  "brown",
  "burlywood",
  "cadetblue",
  "chocolate",
  "coral",
  "cornflowerblue",
  "crimson",
  "darkcyan",
  "darkgoldenrod",
  "darkgray",
  "darkgreen",
  "darkgrey",
  "darkkhaki",
  "darkmagenta",
  "darkolivegreen",
  "darkorange",
  "darkorchid",
  "darkred",
  "darksalmon",
  "darkseagreen",
  "darkslateblue",
  "darkslategray",
  "darkslategrey",
  "darkturquoise",
  "darkviolet",
  "deeppink",
  "deepskyblue",
  "dimgray",
  "dimgrey",
  "dodgerblue",
  "firebrick",
  "forestgreen",
  "fuchsia",
  "gold",
  "goldenrod",
  "gray",
  "green",
  "grey",
  "hotpink",
  "indianred",
  "khaki",
  "lightcoral",
  "lightgreen",
  "lightsalmon",
  "lightseagreen",
  "lightskyblue",
  "lightslategray",
  "lightslategrey",
  "lightsteelblue",
  "lime",
  "limegreen",
  "magenta",
  "mediumaquamarine",
  "mediumblue",
  "mediumorchid",
  "mediumpurple",
  "mediumseagreen",
  "mediumslateblue",
  "mediumturquoise",
  "mediumvioletred",
  "navy",
  "olive",
  "olivedrab",
  "orange",
  "orangered",
  "orchid",
  "palevioletred",
  "peru",
  "pink",
  "plum",
  "purple",
  "red",
  "rosybrown",
  "royalblue",
  "black",
  "saddlebrown",
  "salmon",
  "sandybrown",
  "seagreen",
  "sienna",
  "silver",
  "skyblue",
  "slateblue",
  "slategray",
  "slategrey",
  "springgreen",
  "steelblue",
  "tan",
  "teal",
  "thistle",
  "tomato",
  "turquoise",
  "violet",
  "yellow",
  "yellowgreen",
];

export default getAvatarColor;
